import React from 'react';
import WorkspaceItemContext from '../../../app/contexts/workspace/workspace-item-context';

export default function useDrawingObjectEditLayer() {
    return React.useContext(WorkspaceItemContext).drawingObjectsLayer.drawLayer;
}
